// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"Footer_infoIcon__2MgVy","githubIcon":"Footer_githubIcon__1NA2i","instagramIcon":"Footer_instagramIcon__23OBj","leftAlign":"Footer_leftAlign__F3aYu"};